import { type FC, type ReactNode } from 'react'
import classNames from 'classnames'
import { Tooltip } from '../../../components/Tooltip/Tooltip'

interface InfoTooltipProps {
  title?: string
  content?: ReactNode
  label?: string
  className?: string
}

export const InfoTooltip: FC<InfoTooltipProps> = ({ title, content, label = 'More information', className }) => (
  <Tooltip title={title} tooltipContent={content}>
    <button
      type='button'
      aria-label={label}
      className={classNames('btn btn-link p-0 border-0 d-inline-flex align-items-center', className ?? 'zocks-text-gray-500')}
    >
      <i className='bi bi-info-circle' />
    </button>
  </Tooltip>
)
